import { useEffect, useState } from "react";
import styles from "./ticTacToe.module.scss";
function Square({ value, onClick }) {
	return (
		<button className={styles.square} onClick={onClick}>
			{value}
		</button>
	);
}

function TicTacToe() {
	const [squares, setSquares] = useState(Array(9).fill(null));
	const [isPlayerTurn, setIsPlayerTurn] = useState(true);

	useEffect(() => {
		if (!isPlayerTurn && !calculateWinner(squares) && squares.includes(null)) {
			const timer = setTimeout(() => {
				makeComputerMove();
			}, 500);
			return () => clearTimeout(timer);
		}
	}, [squares, isPlayerTurn]);

	const winner = calculateWinner(squares);
	let status;
	if (winner) {
		status = winner === "X" ? "Вы победили!" : "Компьютер победил!";
	} else if (squares.every((square) => square !== null)) {
		status = "Ничья!";
	} else {
		status = isPlayerTurn ? "Ваш ход" : "Ход компьютера";
	}

	function handleClick(i) {
		if (calculateWinner(squares) || squares[i] || !isPlayerTurn) {
			return;
		}
		const newSquares = squares.slice();
		newSquares[i] = "X";
		setSquares(newSquares);
		setIsPlayerTurn(false);
	}

	function makeComputerMove() {
		const newSquares = squares.slice();

		// Проверка на выигрышный ход компьютера
		for (let i = 0; i < 9; i++) {
			if (newSquares[i] === null) {
				newSquares[i] = "O";
				if (calculateWinner(newSquares) === "O") {
					setSquares(newSquares);
					setIsPlayerTurn(true);
					return;
				}
				newSquares[i] = null;
			}
		}

		// Блокировка выигрышного хода игрока
		for (let i = 0; i < 9; i++) {
			if (newSquares[i] === null) {
				newSquares[i] = "X";
				if (calculateWinner(newSquares) === "X") {
					newSquares[i] = "O";
					setSquares(newSquares);
					setIsPlayerTurn(true);
					return;
				}
				newSquares[i] = null;
			}
		}

		// Занять центр, если свободен
		if (newSquares[4] === null) {
			newSquares[4] = "O";
			setSquares(newSquares);
			setIsPlayerTurn(true);
			return;
		}

		// Занять угол, если свободен
		const corners = [0, 2, 6, 8];
		const freeCorners = corners.filter((corner) => newSquares[corner] === null);
		if (freeCorners.length > 0) {
			const randomCorner = freeCorners[Math.floor(Math.random() * freeCorners.length)];
			newSquares[randomCorner] = "O";
			setSquares(newSquares);
			setIsPlayerTurn(true);
			return;
		}

		// Занять любую свободную клетку
		const emptySquares = newSquares.reduce((acc, square, index) => (square === null ? acc.concat(index) : acc), []);
		if (emptySquares.length > 0) {
			const randomIndex = Math.floor(Math.random() * emptySquares.length);
			newSquares[emptySquares[randomIndex]] = "O";
			setSquares(newSquares);
			setIsPlayerTurn(true);
		}
	}

	function renderSquare(i) {
		return <Square value={squares[i]} onClick={() => handleClick(i)} />;
	}

	function resetGame() {
		setSquares(Array(9).fill(null));
		setIsPlayerTurn(true);
	}

	return (
		<div className={styles.wrapper}>
			<div className={styles.status}>{status}</div>
			<div className={styles["board-row"]}>
				{renderSquare(0)}
				{renderSquare(1)}
				{renderSquare(2)}
			</div>
			<div className={styles["board-row"]}>
				{renderSquare(3)}
				{renderSquare(4)}
				{renderSquare(5)}
			</div>
			<div className={styles["board-row"]}>
				{renderSquare(6)}
				{renderSquare(7)}
				{renderSquare(8)}
			</div>
			<button className={styles["reset-button"]} onClick={resetGame}>
				Начать заново
			</button>
		</div>
	);
}

function calculateWinner(squares) {
	const lines = [
		[0, 1, 2],
		[3, 4, 5],
		[6, 7, 8],
		[0, 3, 6],
		[1, 4, 7],
		[2, 5, 8],
		[0, 4, 8],
		[2, 4, 6],
	];
	for (let i = 0; i < lines.length; i++) {
		const [a, b, c] = lines[i];
		if (squares[a] && squares[a] === squares[b] && squares[a] === squares[c]) {
			return squares[a];
		}
	}
	return null;
}

export default TicTacToe;
